import React from 'react';
import { motion } from 'framer-motion';
import IridescenceBackground from './IridescenceBackground';

const HeroSection: React.FC = () => {
  return (
    <motion.section
      className="tmf-hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Iridescent Background */}
      <IridescenceBackground
        color={[1.0, 0.2, 0.2]}
        speed={0.3}
        amplitude={0.0}
        mouseReact={false}
      />

      <div className="tmf-hero-content">
        {/* Partner Logos */}
        <motion.div
          className="tmf-hero-logos"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <img
            src="/content/tmf data/tmf logos/Toyota Logo.png"
            alt="Toyota"
            className="tmf-hero-logo-item"
          />
          <img
            src="/content/tmf data/tmf logos/TMF Logo.svg"
            alt="Toyota Mobility Foundation"
            className="tmf-hero-logo-item"
          />
          <img
            src="/content/tmf data/tmf logos/GCFB Logo White.png"
            alt="Greater Chicago Food Depository"
            className="tmf-hero-logo-item"
          />
          <img
            src="/content/tmf data/tmf logos/Pantry Southeast Community Services.avif"
            alt="Pantry Southeast Community Services"
            className="tmf-hero-logo-item"
          />
        </motion.div>

        {/* Project Title */}
        <motion.h1
          className="tmf-hero-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Community-Rooted Planning for Mobility as a Social Service
        </motion.h1>

        {/* Conversational Hook */}
        <motion.p
          className="tmf-hero-hook"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          How do you design research for sensitive and vulnerable populations? This question became the foundation of our work with a local food pantry serving 500+ families monthly.
        </motion.p>

        {/* Scroll Indicator */}
        <motion.div
          className="tmf-scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1 }}
        >
          <span className="tmf-scroll-text">Scroll to view</span>
          <motion.span
            className="tmf-scroll-arrow"
            animate={{ y: [0, 10, 0] }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            ↓
          </motion.span>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default HeroSection;
